import { Pane } from 'tweakpane';

class UserInterface {
  constructor(renderer) {
    this.renderer = renderer;

    this.params = {
      'camera pos': {x: 0, y: 0, z: 0},
      'camera dir': {x: 0, y: 0, z: 0},
      'unlock controls': false,

      'chunk borders': false,
      'frustum': false,

      'voxel border w': 0.16,
      'voxel border f': 0.95,
      'voxel chunk step': false,
      'voxel chunk step scale': 500,

      'chunk step': false,
      'chunk step scale': 200,

      'max num chunks': 100,

      'shadow intensity': 0.7,
      'spherical lights': true,
      'sun light': true,
      'animated colors': true,

      // other configs (not rendered)
      'num voxels per texel dim': 2,
      'num voxels per chunk dim': 64,
    };
    this.types = {
      'chunk borders': 'bool',
      'frustum': 'bool',

      'voxel border w': 'float',
      'voxel border f': 'float',
      'voxel chunk step': 'bool',
      'voxel chunk step scale': 'float',

      'chunk step': 'bool',
      'chunk step scale': 'float',

      'max num chunks': 'int',

      'shadow intensity': 'float',
      'spherical lights': 'bool',
      'sun light': 'bool',
      'animated colors': 'bool',

      // other configs (not rendered)
      'num voxels per texel dim': 'int',
      'num voxels per chunk dim': 'int',
    }

    const saved = localStorage.getItem('debugParams');

    // if (saved) {
    //   Object.assign(this.params, JSON.parse(saved));
    // }

    this.params["fps"] = 0;

    this.pane = new Pane({
      title: 'Debug',
      expanded: true,
    });
    this.pane.hidden = true;

    this.pane.on('change', () => {
      localStorage.setItem(
        'debugParams',
        JSON.stringify(this.params, null, 2)
      );
    });

    const perfFolder = this.pane.addFolder({
      title: 'Performance',
      expanded: true,
    });

    perfFolder.addBinding(this.params, 'fps', {
      readonly: true,
      view: 'text',
    });

    const camFolder = this.pane.addFolder({
      title: 'Camera',
      expanded: true,
    });


    camFolder.addBinding(this.params, 'camera pos');
    camFolder.addBinding(this.params, 'camera dir');
    camFolder.addBinding(this.params, 'unlock controls')
      .on('change', (ev) => {
          if (ev.value) {
            console.log("YEE")
              this.renderer.camera.enableControls();
          } else {
            console.log("NOO")
              this.renderer.camera.disableControls();
          }
      });

    const renderFolder = this.pane.addFolder({
      title: 'Rendering',
      expanded: true,
    });

    renderFolder.addBinding(this.params, 'chunk borders');
    renderFolder.addBinding(this.params, 'frustum');

    renderFolder.addBinding(this.params, 'voxel border w', {min: 0.0, max: 1.0, step: 0.01});
    renderFolder.addBinding(this.params, 'voxel border f', {min: 0.0, max: 1.0, step: 0.01});
    renderFolder.addBinding(this.params, 'voxel chunk step');
    renderFolder.addBinding(this.params, 'voxel chunk step scale', {view: 'graph', min: 10, max: 5000});
    renderFolder.addBinding(this.params, 'chunk step');
    renderFolder.addBinding(this.params, 'chunk step scale', {min: 10, max: 5000, step: 1});
    renderFolder.addBinding(this.params, 'max num chunks', {min: 1, max: 1000, step: 1});

    const lightingFolder = this.pane.addFolder({
      title: 'Lighting',
      expanded: true,
    });

    lightingFolder.addBinding(this.params, 'shadow intensity', {
      min: 0,
      max: 1,
      step: 0.01,
    });
    renderFolder.addBinding(this.params, 'spherical lights');
    renderFolder.addBinding(this.params, 'sun light');
    renderFolder.addBinding(this.params, 'animated colors');

    this.pane.addButton({
      title: 'Reload shader',
    }).on('click', async () => {
      await this.renderer.init();
    });

    this.pane.addButton({
      title: 'Reload model',
    }).on('click', async () => {
      await this.renderer.voxel_screen.loadFromFile("models/mainscene.bin");
    });
  }

  render(deltas, camera) {
    const avgDelta = deltas.reduce((a, b) => a + b, 0) / deltas.length;
    this.params.fps = Math.round(1 / avgDelta);

    if(camera !== undefined) {
      this.params["camera pos"].x = camera.position.x;
      this.params["camera pos"].y = camera.position.y;
      this.params["camera pos"].z = camera.position.z;

      this.params["camera dir"].x = camera.direction.x;
      this.params["camera dir"].y = camera.direction.y;
      this.params["camera dir"].z = camera.direction.z;
    }

    this.pane.refresh();
  }
}

export { UserInterface };
